<div class="dataList">
    <div class="records">
        <mat-form-field appearance="outline">
            <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
            <i matSuffix class="flaticon-search"></i>
        </mat-form-field>
        <logzy-reports-table [downloadButtons]="true" [pageName]="'currency_master'"></logzy-reports-table>
    </div>
    <div class="teamTable setTable">
        <ng-container *ngIf="!table_data?.data.length">
            <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
        </ng-container>
        <ng-container *ngIf="table_data?.data.length">
        <mat-table [dataSource]="table_data" matSort (matSortChange)="announceSortChange($event)">
            <ng-container *ngFor="let col of displayedColumnData">
                <ng-container [ngSwitch]="col.colDef">

                    <ng-container *ngSwitchCase="'isEdit'" [matColumnDef]="col.colDef">
                        <mat-header-cell *matHeaderCellDef> {{col.colTitle}} </mat-header-cell>
                        <mat-cell *matCellDef="let data">
                            <div class="actions">
                                <i class="flaticon-view" (click)="actionEdit(data)"></i>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container *ngSwitchCase="'countries'" [matColumnDef]="col.colDef">
                        <mat-header-cell *matHeaderCellDef> {{col.colTitle}} </mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-13" [class.inActive]="!data.is_active">
                            <span *ngFor="let country of data?.[col.colKey] " [class]="col.colKey">
                                {{country?.[col.colValue] ?? '-'}}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <ng-container *ngSwitchDefault [matColumnDef]="col.colDef">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{col.colTitle}} </mat-header-cell>
                        <ng-container *ngIf="col.colValue ">
                            <mat-cell *matCellDef="let data" class="fs-13" [class.inActive]="!data.is_active">
                                {{data[col.colKey]?.[col.colValue] ?? '-'}}
                            </mat-cell>
                        </ng-container>
                        <ng-container *ngIf="col.colKey">
                            <mat-cell *matCellDef="let data" class="fs-13" [class.inActive]="!data.is_active"
                                (click)="actionEdit(data)">
                                {{data[col.colKey] ?? '-'}} </mat-cell>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>


            <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" [class.blur]="update"></mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!update">
            <logzy-gear-loader></logzy-gear-loader>

        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of users"
            [length]="pageLength" (page)="pageChanged($event)">
        </mat-paginator>
        </ng-container>
    </div>
</div>